<template>
    <b-form-row v-if="patient">
        <b-col>
            <b-form-row class="align-items-center">
                <b-col cols="5">
                    <SearchComponent v-model="selectedAllergy" :label="`Allergy Search`"
                        search-u-r-l="/Allergy/GetGSDDAllergies" :disabled="disable" clearable />
                </b-col>
                <b-col cols="5">
                    <b-form-group label="Reaction:">
                        <b-input v-model="reaction" maxlength="100" :disabled="disable" />
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <checkbox v-model="patient.nkda" :disabled="(disable || disableNkda)" @input="nkdaChanged">
                        NKDA
                    </checkbox>
                </b-col>
            </b-form-row>

            <b-button @click="addAllergy" v-if="!disable" variant="success">
                Add Allergy
            </b-button>

            <b-table-simple v-if="!!patientAllergies.length">
                <b-thead>
                    <b-tr>
                        <b-th>Allergen</b-th>
                        <b-th>Type</b-th>
                        <b-th>Reaction</b-th>
                        <b-th>Added Date</b-th>
                        <b-th class="remove"></b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="allergy in patientAllergies" :key="allergy.allergyName">
                        <b-td>{{ allergy.allergyName }}</b-td>
                        <b-td>
                            {{
                                allergy.allergyType == 0 ? 'Class' :
                                    allergy.allergyType == 1 ? 'Ingredient' :
                                        'Drug'
                            }}
                        </b-td>
                        <b-td>
                            {{ allergy.reaction }}
                        </b-td>
                        <b-td>
                            {{ allergy.created | formatDate("LLL") }}
                        </b-td>
                        <b-td>
                            <b-button variant="danger" size="sm" @click="RemoveAllergy(allergy)">Remove</b-button>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-col>
    </b-form-row>
</template>

<script lang="ts">
import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
import { DatePicker } from "element-ui";
import axios from 'axios';
import { NotificationOptions } from "@/util/NotificationOptionsPresets"
import { Patient } from '@/models/Patient';
import SearchComponent from '@/components/SearchComponent.vue';
import NewClearSaveButtons from '@/components/NewClearSaveButtons.vue';
import AddressFormFields from '@/components/AddressFormFields.vue';
import Checkbox from "@/components/Inputs/Checkbox.vue";
import { GSDDPatientAllergy } from "@/models/GSDD";

@Component({
    name: "GSDDAllergyComponent",
    components: {
        SearchComponent,
        NewClearSaveButtons,
        AddressFormFields,
        Checkbox,
        [DatePicker.name]: DatePicker
    }
})
export default class GSDDAllergyComponent extends Vue {
    @Prop({ default: null }) private patient!: Patient;
    @Prop({ default: false }) private disable!: boolean
    @Prop({ default: () => [] }) private value!: GSDDPatientAllergy[];

    //private patientAllergies: GSDDPatientAllergy[] = []
    private selectedAllergy: GSDDPatientAllergy = new GSDDPatientAllergy();
    private reaction: string = "";

    get patientAllergies(): GSDDPatientAllergy[] {
        return this.value;
    }

    set patientAllergies(val: GSDDPatientAllergy[]) {
        this.$emit('input', val);
    }

    get disableNkda(): boolean {
        return this.patientAllergies.length > 0;
    }

    created() {
        this.getPatientGSDDAllergies();
    }

    getPatientGSDDAllergies() {
        if (!this.patient?.id) return;

        axios.get(`/Allergy/GetGSDDAllergiesForPatient/${this.patient.id}`)
            .then(response => {
                this.patientAllergies = response.data.sort((a: GSDDPatientAllergy, b: GSDDPatientAllergy) => {
                    if (!a.created && !b.created) return 0;
                    if (!a.created) return 1;
                    if (!b.created) return -1;
                    return new Date(b.created).getTime() - new Date(a.created).getTime();
                });
            }).catch(error => {
                console.error("Error while loading allergies", { error, response: error?.response });
                this.$notification(NotificationOptions.error(error));
            });
    }

    @Watch('patient.id') onPatientChanged(value: Patient | null, oldValue: Patient | null) {
        this.clearComponent();
        this.getPatientGSDDAllergies();
    }

    nkdaChanged(val: boolean) {
        if (val) {
            this.patientAllergies = [];
        }
    }

    addAllergy() {
        if (!this.selectedAllergy?.allergyName) {
            this.$notification(NotificationOptions.error("Please select an Allergy."));
            return;
        }

        if (this.patientAllergies.includes(this.selectedAllergy)) {
            this.$notification(NotificationOptions.error("This Allergy has already been added."));
            return;
        }

        this.selectedAllergy.patientId = this.patient.id as number;
        this.selectedAllergy.reaction = this.reaction;
        this.selectedAllergy.created = new Date();
        this.patientAllergies.unshift(this.selectedAllergy);
        this.patient.nkda = false;
        this.reaction = "";
    }

    RemoveAllergy(allergy: any) {
        this.patientAllergies = this.patientAllergies.filter(item => item.allergyId != allergy.allergyId);
    }

    clearComponent() {
        this.patientAllergies = new Array<GSDDPatientAllergy>();
        this.selectedAllergy = new GSDDPatientAllergy();
        this.reaction = "";
    }

}
</script>

<style scoped lang="scss">
th.remove {
    width: 110px;
}
</style>
